(function(){
'use strict';

/**
 * @ngDoc directive
 * @name scSvgFill
 *
 * @description
 * Bind the fill of an svg object to the model.
 */

function scSvgFill() {
  return function (scope, element, attrs) {
    scope.$watch(attrs.scSvgFill, function (newVal) {
      element[0].setAttribute('fill', newVal);
    });
  };
}

angular.module('classy').directive('scSvgFill', scSvgFill);
})();